export default function LoadingSpinner() {
   return (
      <div className="flex items-center justify-center h-screen w-screen bg-white">
         <div className="relative flex space-x-2">
            <div className="w-5 h-5 bg-blue-500 rounded-full animate-bounce shadow-lg shadow-blue-300"></div>
            <div className="w-5 h-5 bg-blue-500 rounded-full animate-bounce delay-150 shadow-lg shadow-blue-300"></div>
            <div className="w-5 h-5 bg-blue-500 rounded-full animate-bounce delay-300 shadow-lg shadow-blue-300"></div>
         </div>
      </div>
   );
}
